import { createFileRoute } from "@tanstack/react-router";

import { sessionQuery } from "@/features/auth/queries";
import { masterTypeIndexQuery } from "@/features/master-types/queries";
import { RecordFormPage } from "@/features/records/components/RecordFormPage";
import { recordEditQuery } from "@/features/records/queries";
import { activeSchemaQuery } from "@/features/schema/queries";

/**
 * Editing, whether that means amending an approved record or continuing
 * an open draft. `RecordFormPage` decides which from what the API returns
 * — the two differ in the verb and in whether `If-Match` is required, and
 * neither is something a URL should be asserting.
 */
export const Route = createFileRoute("/_authed/records/$code/$recordId/edit")({
  staticData: {
    crumbs: [
      { key: "nav.records", to: "/records" },
      { param: "code" },
      { key: "nav.breadcrumb.edit" },
    ],
  },
  loader: async ({ context, params }) => {
    const me = await context.queryClient.ensureQueryData(sessionQuery);
    await Promise.all([
      context.queryClient.ensureQueryData(masterTypeIndexQuery(me.resolved_locale)),
      context.queryClient.ensureQueryData(activeSchemaQuery(params.code)),
      context.queryClient.ensureQueryData(recordEditQuery(params.code, params.recordId)),
    ]);
  },
  component: EditRecord,
});

function EditRecord() {
  const { code, recordId } = Route.useParams();
  return <RecordFormPage code={code} recordId={recordId} />;
}
